"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.StyledShowMoreButton = exports.Content = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _localization = require("@lt/localization");
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _iconsReact = require("../../icons-react");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var ExpandButton = function ExpandButton(_ref) {
  var content = _ref.content,
    visibleLine = _ref.visibleLine,
    className = _ref.className;
  var textRef = (0, _react.useRef)(null);
  var _useState = (0, _react.useState)(false),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    isExpanded = _useState2[0],
    setIsExpanded = _useState2[1];
  var _useState3 = (0, _react.useState)(true),
    _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
    isHiddenReview = _useState4[0],
    setIsHiddenReview = _useState4[1];
  var handleExpand = function handleExpand() {
    setIsHiddenReview(false);
  };
  var _useTranslation = (0, _localization.useTranslation)(),
    t = _useTranslation.t;
  (0, _react.useEffect)(function () {
    var _textRef$current, _textRef$current2;
    if (Number(textRef === null || textRef === void 0 || (_textRef$current = textRef.current) === null || _textRef$current === void 0 ? void 0 : _textRef$current.offsetHeight) < Number(textRef === null || textRef === void 0 || (_textRef$current2 = textRef.current) === null || _textRef$current2 === void 0 ? void 0 : _textRef$current2.scrollHeight)) {
      setIsExpanded(true);
    } else {
      setIsExpanded(false);
    }
  }, [content, isHiddenReview]);
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: className
  }, /*#__PURE__*/_react["default"].createElement(Content, {
    isHiddenReview: isHiddenReview,
    visibleLine: visibleLine,
    ref: textRef
  }, content), isExpanded && /*#__PURE__*/_react["default"].createElement(StyledShowMoreButton, {
    onClick: handleExpand
  }, t('hotel.room.moreButton'), /*#__PURE__*/_react["default"].createElement(StyledArrowDown, null)));
};
var Content = exports.Content = _styledComponents["default"].div.withConfig({
  displayName: "ExpandButton__Content",
  componentId: "sc-5h0952-0"
})(["font-size:14px;-webkit-line-clamp:", ";margin-bottom:12px;", "}"], function (_ref2) {
  var visibleLine = _ref2.visibleLine;
  return visibleLine;
}, function (_ref3) {
  var isHiddenReview = _ref3.isHiddenReview;
  return isHiddenReview && "\n    text-overflow: ellipsis;\n    display: -webkit-box;\n    -webkit-box-orient: vertical;\n    overflow: hidden;\n  ";
});
var StyledShowMoreButton = exports.StyledShowMoreButton = _styledComponents["default"].span.withConfig({
  displayName: "ExpandButton__StyledShowMoreButton",
  componentId: "sc-5h0952-1"
})(["color:#007aff;font-size:14px;cursor:pointer;"]);
var StyledArrowDown = (0, _styledComponents["default"])(_iconsReact.ArrowDown).withConfig({
  displayName: "ExpandButton__StyledArrowDown",
  componentId: "sc-5h0952-2"
})(["transform:rotate(180deg);path{fill:#007aff;}height:8px;width:12px;margin-left:4px;"]);
var _default = exports["default"] = ExpandButton;